import {useCallback, useState} from "react";
import {createBsrsFollowUp} from "../api/createBsrsFollowUp";

export const useCreateBsrsFollowUp = ({ name, telephone, pressureEvent, onCompleted }) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const submit = useCallback(async () => {
    setIsLoading(true)
    if (name && telephone) {
      await createBsrsFollowUp({ name, telephone, pressureEvent })
    }
    setIsLoading(false)
    onCompleted();
  }, [name, onCompleted, pressureEvent, telephone])

  return { isLoading, submit }
}